<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-modal
      size="md"
      hide-header-close
      no-close-on-backdrop
      hide-footer
      id="delete-provider"
      title="EXCLUIR FORNECEDOR"
    >
      <div class="row">
        <ReleasesDelete
          type="provider"
          :id="id"
          @total="handleVerifyReleasesToDelete"
        />
        <div class="col-md-12" v-if="totalReleases > 0">
          Há {{ totalReleases }} lançamento(s) cadastrado(s) neste fornecedor. O
          que deseja fazer?
        </div>
        <div class="col-md-12" v-if="totalReleases > 0">
          <div class="form-check">
            <input
              v-model="type_delete"
              class="form-check-input"
              type="radio"
              name="typeDelete"
              id="type_only_delete"
              value="type_only_delete"
            />
            <label class="form-check-label" for="type_only_delete"
              >Deixar todos os lançamentos sem fornecedor</label
            >
          </div>
          <div class="form-check">
            <input
              v-model="type_delete"
              class="form-check-input"
              type="radio"
              name="typeDelete"
              id="type_delete_transfer"
              value="type_delete_transfer"
            />
            <label class="form-check-label" for="type_delete_transfer"
              >Transferir lançamentos para outro fornecedor</label
            >
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="totalReleases > 0 && type_delete == 'type_delete_transfer'"
        >
          <select v-model="transfer_id" class="form-control">
            <option :value="null">SELECIONE...</option>
            <option
              v-for="(item, key) in providers"
              :value="item.id"
              :key="key"
              v-show="item.id != id"
            >
              {{ item.company_name }}
            </option>
          </select>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errorsDelete" />
        </div>
        <div class="col-md-6">
          <v-btn @click="$bvModal.hide('delete-provider')" class="btn-cancel">
            <i class="fas fa-times mr-2 text-twenty"></i>
            CANCELAR
          </v-btn>
        </div>
        <div class="col-md-6 text-right">
          <v-btn :disabled="loading" @click="handleDelete" class="btn-delete">
            <i class="fas fa-check mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "EXCLUIR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="container">
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR
          </v-btn>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1">{{ company_name }}</h1>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <form method="post">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                @click="errors = []"
                class="nav-link link-annotation-care active"
                id="nav-informacoes"
                data-toggle="tab"
                href="#informacoes"
                role="tab"
                aria-controls="informacoes"
                aria-selected="true"
                >INFORMAÇÕES</a
              >
              <a
                @click="errors = []"
                class="nav-link link-annotation-care"
                id="nav-endereco"
                data-toggle="tab"
                href="#endereco"
                role="tab"
                aria-controls="endereco"
                aria-selected="false"
                >ENDEREÇO</a
              >
              <a
                @click="errors = []"
                class="nav-link link-annotation-care"
                id="nav-informacoes-bancaria"
                data-toggle="tab"
                href="#informacoes-bancaria"
                role="tab"
                aria-controls="informacoes-bancaria"
                aria-selected="false"
              >
                INFORMAÇÕES BANCÁRIAS
              </a>
            </div>
          </nav>
          <div class="tab-content">
            <div
              class="tab-pane fade show active"
              id="informacoes"
              role="tabpanel"
              aria-labelledby="nav-informacoes"
            >
              <div class="row pt-4">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-0">
                  <v-text-field
                    hide-details
                    ref="autofocus"
                    v-model="company_name"
                    label="Nome/Razão social*"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-model="fantasy_name"
                    label="Nome fantasia"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div
                  class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 d-flex justify-content-center align-items-center"
                >
                  <b-checkbox
                    :value="1"
                    :unchecked-value="0"
                    v-model="is_foreign"
                  >
                    <h6 class="my-0">Estrangeiro</h6>
                  </b-checkbox>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-model="ie"
                    label="I.E."
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-model="im"
                    label="I.M."
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-mask="'(##) # ####-####'"
                    v-model="phone"
                    label="Telefone"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-model="email"
                    label="E-mail"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-model="cpf_cnpj"
                    label="CPF/CNPJ"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pb-0">
                  <v-select
                    label="STATUS"
                    hide-details
                    outlined
                    dense
                    :items="active_status"
                    v-model="active"
                  >
                  </v-select>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pb-0">
                  <v-select
                    label="CLASSIFICAÇÃO"
                    hide-details
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    :items="availableClassifications"
                    v-model="provider_classification_id"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="endereco"
              role="tabpanel"
              aria-labelledby="nav-endereco"
            >
              <div class="row pt-4">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                  <VTextFieldCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
                </div>
                <div class="col-xl-7 col-lg-7 col-md-7 col-sm-8 col-12">
                  <v-text-field
                    hide-details
                    v-model="address"
                    label="Endereço"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12">
                  <v-text-field
                    hide-details
                    v-model="number_address"
                    label="Nº"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                  <v-text-field
                    hide-details
                    v-model="complement"
                    label="Complemento"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                  <v-text-field
                    hide-details
                    v-model="neighborhood"
                    label="Bairro"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                  <v-text-field
                    hide-details
                    v-model="city"
                    label="Cidade"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                  <v-select
                    hide-details
                    v-model="uf_id"
                    :items="ufs"
                    label="Estado"
                    dense
                    outlined
                    item-value="id"
                    item-text="name"
                  />
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="informacoes-bancaria"
              role="tabpanel"
              aria-labelledby="nav-informacoes-bancaria"
            >
              <div class="row pt-4">
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                >
                  <label>Banco</label>
                  <treeselect
                    :multiple="false"
                    :options="[
                      { id: '', label: 'SELECIONE...', children: [] },
                      ...banks,
                    ]"
                    placeholder="SELECIONE..."
                    v-model="bank_id"
                    noChildrenText="NÃO POSSUI BANCO(S) FILHO(S)"
                  />
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-model="agency"
                    label="Agência"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-12 pb-0">
                  <v-text-field
                    hide-details
                    v-model="account"
                    label="Conta"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                >
                  <v-textarea
                    hide-details
                    v-model="note"
                    label="Observação"
                    outlined
                    dense
                  ></v-textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
            <WarningRequiredFields />
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
              <h6 class="worksansr">
                Criação:
                {{ formatDate(created_at) }}
              </h6>
              <h6 class="worksansr">
                Última alteração:
                {{ formatDate(updated_at) }}
              </h6>
            </div>
            <div
              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center justify-content-end"
            >
              <v-btn
                v-if="
                  permission('remove', 'financial_provider') ||
                  permission('remove', 'provider')
                "
                :disabled="loadingDelete"
                :loading="loadingDelete"
                class="btn-delete mr-1"
                @click="deleteProvider"
              >
                <i class="fas fa-trash mr-2"></i>
                EXCLUIR</v-btn
              >
              <v-btn-timeout :disabled="loading" @click="update" />
            </div>
          </div>
        </form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import WarningRequiredFields from "../templates/Components/WarningRequiredFields";

import VTextFieldCEP from "../templates/Components/VTextFieldCEP.vue";

import VBtnTimeout from "../templates/Components/VBtnTimeout.vue";

import Treeselect from "@riophae/vue-treeselect";

import ReleasesDelete from "../templates/Financial/Configuration/Delete/releases.vue";

import api from "../services/api";

import toast from "../lib/ToastNotification";

import { formatDate } from "../lib/format";

import { getStatic } from "../lib/functions";

import permission from "../lib/permission";

export default {
  name: "Provider",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningRequiredFields,
    VTextFieldCEP,
    VBtnTimeout,
    Treeselect,
    ReleasesDelete,
  },

  data() {
    return {
      totalReleases: 0,
      type_delete: null,
      transfer_id: null,
      errors: [],
      errorsDelete: [],
      loading: true,
      loadingDelete: false,

      active_status: [
        { text: "ATIVO", value: 1 },
        { text: "INATIVO", value: 0 },
      ],
      classifications: [],
      ufs: [],
      banks: [],
      providers: [],

      id: "",

      company_name: "",
      fantasy_name: "",
      is_foreign: 0,
      ie: "",
      im: "",
      phone: "",
      email: "",
      cpf_cnpj: "",
      active: 0,
      provider_classification_id: null,

      cep: "",
      address: "",
      number_address: "",
      complement: "",
      neighborhood: "",
      city: "",
      uf_id: "",

      bank_id: "",
      agency: "",
      account: "",
      note: "",

      created_at: "",
      updated_at: "",
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    availableClassifications() {
      return this.classifications.filter(
        (item) => item.active || item.id === this.provider_classification_id
      );
    },
  },

  methods: {
    permission,
    formatDate,

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async retrieve() {
      this.id = this.$router.currentRoute.params.id;

      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.banks = (await getStatic("/banks", true)).banks;
      } catch (errors) {
        this.errors = errors;
      }

      if (this.errors.length === 0) await this.getClassifications();
      if (this.errors.length === 0) await this.get();
      if (this.errors.length === 0) await this.getProviders();
    },

    async getClassifications() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/providers/classifications");
        const { error, errors, classifications } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.classifications = [
            ...classifications,
            { id: "", name: "SELECIONE...", active: 1 },
          ];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getProviders() {
      try {
        const params = { active: 1 };
        const response = await api.get("/rest-home/providers", {
          params,
        });

        const { providers } = response.data;

        this.providers = providers;
      } catch (error) {
        console.log(error);
      }
    },

    async get() {
      try {
        this.loading = true;

        const { id } = this;
        const response = await api.get("/rest-home/provider", {
          params: { id },
        });

        const { error, errors, provider } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          this.company_name = provider.company_name;
          this.fantasy_name = provider.fantasy_name;
          this.is_foreign = provider.is_foreign;
          this.ie = provider.ie;
          this.im = provider.im;
          this.phone = provider.phone;
          this.email = provider.email;
          this.cpf_cnpj = provider.cpf_cnpj ?? "";
          this.active = provider.active;
          this.provider_classification_id = provider.provider_classification_id;

          this.cep = provider.cep;
          this.address = provider.address;
          this.number_address = provider.number_address;
          this.complement = provider.complement;
          this.neighborhood = provider.neighborhood;
          this.city = provider.city;
          this.uf_id = provider.uf_id;

          this.bank_id = provider.bank_id;
          this.agency = provider.agency;
          this.account = provider.account;
          this.note = provider.note;

          this.created_at = provider.created_at;
          this.updated_at = provider.updated_at;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async update() {
      try {
        this.loading = true;

        const params = {
          id: this.id,

          //#region INFORMAÇÕES
          company_name: this.company_name,
          fantasy_name: this.fantasy_name,
          is_foreign: this.is_foreign,
          ie: this.ie,
          im: this.im,
          phone: this.phone,
          email: this.email,
          cpf_cnpj: this.cpf_cnpj,
          active: this.active,
          provider_classification_id: this.provider_classification_id,
          //#endregion

          //#region ENDEREÇO
          cep: this.cep,
          address: this.address,
          number_address: this.number_address,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          uf_id: this.uf_id,
          //#endregion

          //#region INFORMAÇÕES BANCÁRIAS
          bank_id: this.bank_id,
          agency: this.agency,
          account: this.account,
          note: this.note,
          //#endregion
        };
        const response = await api.patch("/rest-home/provider", params);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$router.go(-1);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async handleDelete() {
      try {
        this.loadingDelete = true;

        let { id, transfer_id, type_delete } = this;

        const data = { id, transfer_id, type_delete };

        const response = await api.delete("/rest-home/provider", { data });

        const { error, errors, message } = response.data;

        if (error) {
          this.errorsDelete = errors;
        } else {
          this.errorsDelete = [];
          toast(message, "success");
          this.$router.go(-1);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingDelete = false;
      }
    },

    deleteProvider() {
      this.$bvModal.show("delete-provider");
    },

    handleVerifyReleasesToDelete(total) {
      this.totalReleases = total;

      if (total == 0) {
        this.type_delete = "type_only_delete";
      } else {
        this.type_delete = null;
      }
    },
  },
};
</script>
